import type { AttendeeInfoDTO } from '@interfaces/referrfer';
import { atom } from 'jotai';

export const loginInfo = atom<AttendeeInfoDTO>({
  applySector: '',
  displayNo: 0,
  name: '',
  recruitNoticeName: '',
});
